var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'priorityButton',
    _vm.size ? ("priorityButton--" + _vm.size) : '',
    _vm.highPriority ? 'priorityButton--priority' : '',
    _vm.disabled ? 'is-disabled' : '',
    _vm.danger ? 'priorityButton--danger' : '',
    _vm.type ? ("priorityButton--" + _vm.type) : '' ],attrs:{"disabled":_vm.disabled,"type":_vm.nativeType},on:{"click":_vm.emitClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }